import React, { FC, useMemo } from 'react'
import { CustomPosition } from 'Pages/landings/newLandings/common/components'
import { useWindowSize } from 'Pages/landings/newLandings/common/hooks'
import { ElementWithIconComponent } from './ElementWithIcon'
import { FirstIcon, SecondIcon, ThirdIcon, FourthIcon } from './Icon'
import forOutletWebp from './forOutlet.webp'
import forOutletJpg from './forOutlet.jpg'
import { Title, ListWithImgWrapper, LinkDashed, Subtitle, TooltipComponent } from './styled'

const calculateCoordX = (width: number) => {
	if (width > 670 && width < 905) return 0
	if (width > 497 && width < 670) return 100
	if (width > 443 && width < 497) return 50
	if (width < 443) return 0
	return 50
}
export const ForOutletComponent: FC = () => {
	const { width } = useWindowSize()

	const coordX = calculateCoordX(width)

	const setCustomPosition = useMemo(
		(): CustomPosition => ({
			name: 'setCustomPosition',
			fn: ({ x, y }) => ({
				x: x + coordX,
				y,
			}),
		}),
		[coordX]
	)
	return (
		<ListWithImgWrapper imgWebp={forOutletWebp} imgJpg={forOutletJpg} isReverse>
			<Title>4 шага для регистрации бизнеса</Title>
			<ElementWithIconComponent
				icon={() => <FirstIcon />}
				title="Заполните форму заявки ниже"
				subtitle="Мы перезвоним и ответим на вопросы"
			/>
			<ElementWithIconComponent
				icon={() => <SecondIcon />}
				title="Мы пригласим вас для подготовки и подписания документов"
			>
				<Subtitle>
					Это можно сделать в офисе Сбера или{' '}
					<TooltipComponent
						tooltipId="order_manager_service"
						title="Доступно в отдельных городах с данным сервисом"
						middlewares={[setCustomPosition]}
						noArrow
					>
						<LinkDashed>заказать услугу выездного менеджера</LinkDashed>
					</TooltipComponent>
					. Мы отправим документы в налоговую в этот же день
				</Subtitle>
			</ElementWithIconComponent>
			<ElementWithIconComponent
				icon={() => <ThirdIcon />}
				title="Дождитесь решения ФНС"
				subtitle="Срок регистрации бизнеса — от 1 рабочего дня"
			/>
			<ElementWithIconComponent
				icon={() => <FourthIcon />}
				title="Начните работу и используйте расчетный счет для бизнеса"
				subtitle="Мы бесплатно откроем расчетный счет, как только ФНС зарегистрирует ваш бизнес"
			/>
		</ListWithImgWrapper>
	)
}
